// Migrated 1:1 from @nexato/nx-core-module (issue/components/issue-status-icon.component.ts, #688)
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IssueStatus } from '../../entities/issue/issue-status';

@Component({
    selector: 'app-issue-status-icon',
    template: `
        <div style="line-height: 0;">
            @switch (issueStatus()?.statusGroup?.code) {
                @case ('TRIAGE') {
                    <svg
                        width="14" height="14" viewBox="0 0 14 14" fill="none" style="vertical-align: top; transform: translateY(-1px);">
                        <circle cx="7" cy="7" r="6" [attr.stroke]="issueStatus()?.color" stroke-width="2" fill="none"/>
                        <path d="M7 9.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" [attr.stroke]="issueStatus()?.color" stroke-width="1" fill="none"/>
                        <circle cx="7" cy="7" r="1" [attr.fill]="issueStatus()?.color"/>
                    </svg>
                }
                @case ('TODO') {
                    <svg
                        width="14" height="14" viewBox="0 0 14 14" fill="none" style="vertical-align: top; transform: translateY(-1px);">
                        <circle cx="7" cy="7" r="6" [attr.stroke]="issueStatus()?.color" stroke-width="2" fill="none"/>
                        <circle cx="7" cy="7" r="2" [attr.fill]="issueStatus()?.color"/>
                    </svg>
                }
                @case ('IN_PROGRESS') {
                    <svg
                        width="14" height="14" viewBox="0 0 14 14" fill="none" style="vertical-align: top; transform: translateY(-1px);">
                        <circle cx="7" cy="7" r="6" [attr.stroke]="issueStatus()?.color" stroke-width="2" fill="none"/>
                        <circle cx="7" cy="7" r="1" [attr.fill]="issueStatus()?.color"/>
                        <circle cx="7" cy="4" r="0.5" [attr.fill]="issueStatus()?.color"/>
                        <circle cx="10" cy="7" r="0.5" [attr.fill]="issueStatus()?.color"/>
                        <circle cx="7" cy="10" r="0.5" [attr.fill]="issueStatus()?.color"/>
                        <circle cx="4" cy="7" r="0.5" [attr.fill]="issueStatus()?.color"/>
                    </svg>
                }
                @case ('DONE') {
                    <svg
                        width="14" height="14" viewBox="0 0 14 14" fill="none" style="vertical-align: top;">
                        <circle cx="7" cy="7" r="6" [attr.stroke]="issueStatus()?.color" stroke-width="2" [attr.fill]="issueStatus()?.color"/>
                        <path d="M4 7l2 2 4-4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                }
                @case ('CANCELED') {
                    <svg
                        width="14" height="14" viewBox="0 0 14 14" fill="none" style="vertical-align: top;">
                        <circle cx="7" cy="7" r="6" [attr.stroke]="issueStatus()?.color" stroke-width="2" [attr.fill]="issueStatus()?.color"/>
                        <path d="M5 5l4 4M9 5l-4 4" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                }
            }
        </div>
    `,
    styles: [`
        svg {
            display: block;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssueStatusIconComponent {

    readonly issueStatus = input<IssueStatus>();

}
